import { render, staticRenderFns } from "./shifts.vue?vue&type=template&id=8b0d658a&scoped=true&"
import script from "./shifts.vue?vue&type=script&lang=js&"
export * from "./shifts.vue?vue&type=script&lang=js&"
import style0 from "./shifts.vue?vue&type=style&index=0&id=8b0d658a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0d658a",
  null
  
)

export default component.exports